import React from "react";
import Nft2 from "assets/img/nfts/Nft2.png";
import Nft1 from "assets/img/nfts/Nft1.png";
import Nft3 from "assets/img/nfts/Nft3.png";
import Nft4 from "assets/img/nfts/Nft4.png";
import Nft5 from "assets/img/nfts/Nft5.png";
import Nft6 from "assets/img/nfts/Nft6.png";

import { FaClock, FaDollarSign, FaEthereum, FaTimes } from "react-icons/fa";
import Card from "components/card";

const HistoryCard = () => {
  const HistoryData = [
    {
      image: Nft2,
      title: "Youtube Campaign Report",
      owner: "Xion X",
      time: "Aug, 15 2023",
    },
    {
      image: Nft2,
      title: "Portfolio Report",
      owner: "Santo G",
      time: "Sep, 15 2023",
    },
    {
      image: Nft2,
      title: "Time Tracking Report",
      owner: "Techzo",
      time: "Oct, 29 2023",
    },

  ];

  return (
    <Card extra={"!z-5 overflow-hidden"}>
      {/* HistoryCard Header */}
      <div className="flex items-center justify-between rounded-t-3xl p-3">
        <div className="text-lg font-bold text-navy-700 dark:text-white">
        Recent reports
        </div>
        <button className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20">
          See all
        </button>
      </div>

      {/* History CardData */}

      {HistoryData.map((data, index) => (
        <div className="flex h-full w-full items-start justify-between bg-white px-3 py-[15px] hover:shadow-2xl dark:!bg-navy-800 dark:shadow-none dark:hover:!bg-navy-700">
          <div className="flex items-center gap-3">
            {/* <div className="flex h-16 w-16 items-center justify-center">
              <img
                className="h-full w-full rounded-xl"
                src={data.image}
                alt=""
              />
            </div> */}
            <div className="flex flex-col">
              <h5 className="text-base font-bold text-navy-700 dark:text-white">
                {" "}
                {data.title}
              </h5>
              <p className="mt-1 text-sm font-normal text-gray-600">
                {" "}
                {data.owner}{" "} , {" "} {data.time} 
              </p>
            </div>
          </div>

          <div className="mt-1 flex items-center justify-center text-navy-700 dark:text-white">
            {/* <div>
              <FaDollarSign />
            </div>
            <div className="ml-1 flex items-center text-sm font-bold text-navy-700 dark:text-white">
              <p> {} </p>
              {data.price} 
            </div> */}
            <div className="ml-2 flex items-center text-sm font-normal text-gray-600 dark:text-white">
              <a href="#">
              <button className="transition duration-200 hover:!text-brand-700 active:!bg-white/70">View PDF</button>
              </a>
             
              {/* <p>{data.time}</p> */}
              {/* <p className="ml-1">ago</p>  */}
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
};

export default HistoryCard;
